import dayjs from "dayjs"
import { RRule } from "rrule"
import { RuleStrType, RuleType } from "."
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(customParseFormat)

export function ruleArrayToString(rules: RuleType[]) {
  if (!rules.length) return null
  return rules
    .map(rule => {
      if (rule.type.includes("DATE") && rule.rule instanceof Date) {
        return `${rule.type}:${dayjs(rule.rule).format("YYYYMMDDTHHmmss")}`
      } else {
        if (rule.type.includes("RULE") && rule.type.startsWith("EX")) {
          return rule.rule.toString().replace("RRULE", rule.type)
        } else {
          return rule.rule.toString()
        }
      }
    })
    .join("\n")
}

export function ruleStringToArray(rules: string) {
  if (!rules) return []

  const rulesArr = rules.split("\n")

  return rulesArr.map(rule => {
    const [type, obj] = rule.split(":")

    if (type.includes("RULE")) {
      return {
        rule: RRule.fromString(`RRULE:${obj}`),
        type: type as RuleStrType,
      }
    } else {
      return {
        rule: dayjs(obj, "YYYYMMDDTHHmmss").toDate(),
        type: type as RuleStrType,
      }
    }
  })
}

export function excludeDate(date: Date) {
  return {
    rule: date,
    type: "EXDATE" as RuleStrType,
  }
}

export function includeDate(date: Date) {
  return {
    rule: date,
    type: "RDATE" as RuleStrType,
  }
}
